var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKefu3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3D6BF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_2354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.999 15.5433C27.4106 15.7971 26.7703 15.9797 26.1108 16.0509C26.7915 15.6452 27.3087 15.0049 27.5529 14.2434C26.9242 14.6184 26.2127 14.8933 25.4724 15.0356C24.8725 14.3953 24.0207 13.9992 23.0765 13.9992C21.2594 13.9992 19.7981 15.4721 19.7981 17.2796C19.7981 17.5334 19.8289 17.7872 19.8788 18.0314C17.158 17.8891 14.7314 16.5893 13.1181 14.5991C12.8335 15.0875 12.672 15.6452 12.672 16.2547C12.672 17.393 13.2508 18.3968 14.1334 18.9871C13.595 18.9659 13.0874 18.814 12.6509 18.5698V18.6102C12.6509 20.2042 13.7777 21.5252 15.2794 21.829C15.0044 21.9002 14.7102 21.9406 14.416 21.9406C14.2026 21.9406 14.0007 21.9194 13.7969 21.8906C14.2122 23.1904 15.4217 24.1345 16.8619 24.1653C15.7351 25.0479 14.3237 25.5671 12.7912 25.5671C12.5163 25.5671 12.2625 25.5574 11.999 25.5267C13.4527 26.4593 15.1775 26.9977 17.035 26.9977C23.065 26.9977 26.3646 22.0021 26.3646 17.6661C26.3646 17.5238 26.3646 17.3815 26.355 17.2392C26.9934 16.772 27.5529 16.1932 27.999 15.5433Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_2354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11.999 11.9992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKefu3);
export default __webpack_public_path__ + "static/media/kefu3.a4e919fb2593deebfc0a993d91ac0842.svg";
export { ForwardRef as ReactComponent };